import React, { useEffect } from "react";
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/Footer";
import CustomTitle from "../../components/common/title/CustomTitle";
import NormalBtn from "../../components/common/button/NormalBtn";
import NormalInput from "../../components/common/input/NormalInput";
import NormalInputGuide from "../../components/common/input/NormalInputGuide";
import CheckBoxInput from "../../components/common/input/CheckBoxInput";
import { useState } from "react";
import { registAction, resetRegStatusAction } from "../../modules/su/userModule";
import { useHistory, Redirect } from "react-router-dom";
import LoadingOverlay from 'react-loading-overlay';
import Modal from 'react-modal';
import BootPay from "bootpay-js";
import { random } from "lodash";
import PolocyPopup, { PolocyPopupModalStyles } from "../../components/common/popup/PolocyPopup";
import PrivacyPopup from "../../components/common/popup/PrivacyPopup";
import NormalPopupOneBtn, { NomalPopupOneBtnStyles } from "../../components/common/popup/NormalPopupOneBtn";
import { Log } from "../../lib/util/CustomUtil";
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

/**
 * 회원가입
 */
const SuSignupBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    padding-top: ${isMobileOnly?'60px':'80px'};
`;

const SuSignupContentsBlock = styled.div`
    padding: ${isMobileOnly?'8vw 0 9vw':'90px 0 120px'}; ;
    background-color: #f4f4f4;
    
`;

const SuSignupBoxBlock = styled.div`
${isMobileOnly?`
    padding: 10vw 4vw;
    margin: 0 auto;  
    max-width: 520px; 
  `:`
    width: 520px;
    padding: 50px 60px;
    margin: 0 auto;
  `};
    
    background-color: #fff;
    border-radius: 6px;
`;

const SuSignup = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [confirm, setConfirm] = useState(false); //test
    const [confirmData, setConfirmData] = useState(null);

    // Check box value
    const [allAgree, setAllAgree] = useState(false);
    const [age, setAge] = useState(false);
    const [policy, setPolicy] = useState(false);
    const [privacy, setPrivacy] = useState(false);
    const [marketing, setMarketing] = useState(false);
    // Input Value
    const [email, setEmail] = useState(null);
    const [passwd, setPasswd] = useState(null);
    const [passwdErrTxt, setPasswdErrTxt] = useState(" ! 6자~20자 이내의 영문+숫자+특수문자의 조합으로 입력해주세요.");
    const [passwdConfirm, setPasswdConfirm] = useState(null);
    const [passwdConfirmErrTxt, setPasswdConfrimErrTxt] = useState(" ! 입력하신 비밀번호와 동일하게 입력해주세요.");

    const [nickname, setNickname] = useState(null);
    const [nicknameHolder, setNicknameHolder] = useState(null);
    const [submitEnable, setSubmitEnable] = useState(false);
    // Error
    const [emailErr, setEmailErr] = useState(false);
    const [emailErrTxt, setEmailErrTxt] = useState(" ! 이메일 형식이 올바르지 않습니다.")
    const [passwdErr, setPasswdErr] = useState(false);
    const [passwdConfirmErr, setPasswdComfirmErr] = useState(false);
    const [nickNameErr, setNickNameErr] = useState(false);
    const [nickNameErrTxt, setNickNameErrTxt] = useState(" ! 닉네임 4자 이상 입력해주세요.");

    const [openModal, setOpenModal] = useState(false);
    const [kindModal, setKindModal] = useState(0);

    const nick1 = ['견고한', '우직한', '따뜻한', '독특한', '내추럴한', '단단한', '결이고운'];
    const nick2 = ['호두나무', '오동나무', '물푸레나무', '소나무', '레드우드', '단풍나무', '버드나무', '떡갈나무', '참나무',
        '느티나무', '자작나무', '참죽나무', '티크나무'];

    const { registError, loading, regStatus, accessToken } = useSelector(
        ({ userReducer, loadingReducer }) => ({
            registError: userReducer.registError,
            loading: loadingReducer['user/REGIST'],
            regStatus: userReducer.regStatus,
            accessToken: userReducer.accessToken
        })
    );

    useEffect(() => {
        dispatch(setCurMenuAction('su/signup'));
        dispatch(setHeaderTransferAction(false));

        /* if (isChrome === false || isMobileOnly) {
            alert("어디가구는 크롬 PC 화면에 최적화 되어있습니다.")
        } */
        /* if (isIE) {
            alert("어디가구는 크롬 브라우저에 최적화되어 있으며, 인터넷 익스플로러에서는 정상적으로 동작하지 않을 수 있음을 양해 부탁드립니다.")
        } */
        if (nickname === null) {
            let nickText = nick1[random(nick1.length - 1)] + nick2[random(nick2.length - 1)] + random(9999);
            setNickname(nickText);
            if(nicknameHolder === null){
                setNicknameHolder(nickText);
            }

        }

        checkSubmitEnable();

        // 등록 실패시 Error 처리 필요
        if (regStatus !== null && regStatus !== 200 && registError !== null) {
            // console.log(regStatus + 'registError : ' + JSON.stringify(registError));
            if (regStatus > 500) {
                dispatch(resetRegStatusAction());
            } else {
                if(regStatus === 300){
                    setEmailErr(true);
                    setEmailErrTxt(" ! 이미 어디가구에 가입되어있는 이메일 주소입니다.");
                    dispatch(resetRegStatusAction());
                }
                else{
                    setKindModal(3);

                    onOpenModal();
                }
            }

        } else if (regStatus === 200) {
            // 가입 완료 시 로그인 화면 으로 이동
            setKindModal(4);
            onOpenModal();
            // return <Redirect to='/login' />
        } else {
            dispatch(resetRegStatusAction());
        }

        // window.scrollTo(0, 0);
    }, [registError, loading, kindModal, age, policy, privacy, emailErr
        , passwdErr, passwdConfirmErr, nickNameErr]);


    const checkAllAgree = (ageval, polval, prival, markval) => {
        if (ageval && polval && prival) {
            setAllAgree(markval ? true : false);
        } else {
            setAllAgree(false);
        }
    }

    const checkSubmitEnable = () => {
        if (age && policy && privacy && !emailErr
            && !passwdErr && !passwdConfirmErr && !nickNameErr) {
            if (validateNickName(nickname) && validatePassword(passwd) &&
                validateEmail(email) && (passwd === passwdConfirm)) {
                setSubmitEnable(true);
            } else {
                setSubmitEnable(false);
            }
        } else {
            setSubmitEnable(false);
        }
    }

    const handleAllAgree = (value) => {
        // console.log("value : " + value);
        setAllAgree(value);
        setAge(value);
        setPolicy(value);
        setPrivacy(value);
        setMarketing(value);
    }

    const handleAge = (value) => {
        setAge(value);
        checkAllAgree(value, policy, privacy, marketing);
    }

    const handlePolicy = (value) => {
        setPolicy(value);
        checkAllAgree(age, value, privacy, marketing);
    }

    const handlePolicyPopup = (value) => {
        setKindModal(1);
        onOpenModal();
    }

    const handlePrivacy = (value) => {
        setPrivacy(value);
        checkAllAgree(age, policy, value, marketing);
    }

    const handlePrivacyPopup = (value) => {
        setKindModal(2);
        onOpenModal();
    }

    const handleMarketing = (value) => {
        setMarketing(value);
        checkAllAgree(age, policy, privacy, value);
    }

    const handleEmailInput = (e) => {
        // console.log("email value : " + e.target.value);
        setEmail(e.target.value);
        setEmailErr(!validateEmail(e.target.value));
        if(!validateEmail(e.target.value)) {
            setEmailErrTxt(" ! 이메일 형식이 올바르지 않습니다.");
        }
    }

    const handlePasswdInput = (e) => {
        // console.log("passwd value : " + e.target.value);
        setPasswd(e.target.value);
        let valid = !validatePassword(e.target.value);
        if (valid) {
            setPasswdErrTxt(" ! 6자~20자 이내의 영문+숫자+특수문자의 조합으로 입력해주세요.")
        }
        setPasswdErr(valid);
    }

    const handlePasswdConfirmInput = (e) => {
        setPasswdConfirm(e.target.value);
        setPasswdComfirmErr(passwd !== e.target.value);
        if (passwd !== e.target.value) {
            if(e.target.value.length > 0){
                setPasswdConfrimErrTxt(" ! 입력하신 비밀번호가 맞지 않습니다. 다시 한번 확인해주세요.");
            }
            else {
                setPasswdConfrimErrTxt(" ! 입력하신 비밀번호와 동일하게 입력해주세요.");
            }
        }
    }

    const handleNicknameInput = (e) => {
        setNickname(e.target.value);
        setNickNameErr(!validateNickName(e.target.value));

        if(!validateNickName(e.target.value)){
            if(e.target.value.length > 0){
                setNickNameErrTxt(" ! 띄어스기, 특수문자를 사용할 수 없습니다.");
            }
            else {
                setNickNameErrTxt(" ! 닉네임 4자 이상 입력해주세요.");
            }
        }
    }

    const validateEmail = (value) => {
        if (value === null) return false;
        var regex = /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return (value !== '' && value !== 'undefined' && regex.test(value));
    };

    const validatePassword = (value) => {
        var regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?=+\(\)\.\-&])[A-Za-z\d$@$!%*#?=+\(\)\.\-&]{6,20}$/;
        if (value === null) return false;
        return regex.test(value);
    }

    const validateNickName = (value) => {
        if (value === null) return false;

        if (value.length > 3 && value.length < 21) {
            // 공백 체크
            if (value.search(/\s/) > -1) return false;

            // 특수문자체크
            var special_pattern = /[~!@#$%^&*()_+|<>?:{}]/;
            return !special_pattern.test(value);
        }

        return false;
    }

    // Modal 열기
    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setKindModal(0);
        setOpenModal(false);
    }

    const handleConfirmClick = () => {
        if (confirm === false) {

            let d = new Date();
            // 본인 인증 처리 시작
            Log(" 본인 인증 처리 시작 ---------> " + process.env.REACT_APP_BOOTPAY_ID);

            BootPay.request({
                price: 0, // 0으로 해야 한다.
                application_id: process.env.REACT_APP_BOOTPAY_ID,
                name: process.env.REACT_APP_BOOTPAY_NAME, //결제창에서 보여질 이름
                pg: 'danal',
                method: 'auth', // 빌링키를 받기 위한 결제 수단
                show_agree_window: 0, // 부트페이 정보 동의 창 보이기 여부
                order_id: 'ODGAGU' + d.getTime(),
                params: {},
                extra: {
                    age_limit: '14'
                }
            }).error(function (data) {
                // 본인인증 진행시 에러가 발생하면 수행됩니다.
                // console.log(" error : " + JSON.stringify(data));
            }).cancel(function (data) {
                // 본인인증이 취소되면 수행됩니다.
                // console.log("취소 : " + JSON.stringify(data));
                // alert('본인인증 중 오류가 발생하였습니다.' + JSON.stringify(data));
            }).done(function (data) {
                // 본인인증이 완료되면 관련된 값이 리턴된다.
                // console.log("완료 : " + JSON.stringify(data));
                setConfirmData(data);
                setConfirm(true);
            });
        }
    }

    // 가입하기 버튼 처리
    const handleSubmit = () => {

        // 필수 체크 안하면 활성화 안됨
        if (submitEnable === false) return;

        if (confirm === false || confirmData === null) {
            alert("본인인증 미처리")
            return;
        }
        let isMkt = 'false';
        if(marketing){
            isMkt = 'true';
        }
        // 모두 다 통과하면 회원 가입 시작
        dispatch(registAction(email, passwd, nickname, confirmData.receipt_id, isMkt));
    }

    const handlePopupClick = () => {
        dispatch(resetRegStatusAction());
        setOpenModal(false);
        // console.log("kindModal : " + kindModal);
        if (kindModal === 4) {
            return history.push('/login');
            // return <Redirect to='/login' />
        }
    }

    // Get Popup Component
    const getPopupComp = () => {

        if (kindModal === 1) {
            return <PolocyPopup onClickIcon={handlePopupClick} />
        } else if (kindModal === 2) {
            return <PrivacyPopup onClickIcon={handlePopupClick} />
        } else {
            return <NormalPopupOneBtn
                text=""
                text2={registError} text3=""
                btn="확인" onClick={handlePopupClick} />
        }
    }

    const getPopupStyle = () => {
        if (kindModal < 3) {
            return PolocyPopupModalStyles;
        } else {
            return NomalPopupOneBtnStyles;
        }
    }

    // 로그인 상태이면
    if (accessToken !== null && accessToken.length > 0) {
        return <Redirect to="/" />
    }

    return (
        <SuSignupBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
                <Header />
                <SuSignupContentsBlock>
                    <SuSignupBoxBlock>
                        <CustomTitle title="회원가입" textColor="#111" />
                        <div className="margin_b-40">
                            <NormalBtn width="100%"
                                onClick={handleConfirmClick}
                                lineHeight="58px"
                                height="60px" borderRadius="30px"
                                fontSize="22px" fontWeight="500"
                                marginTop="0px" float="none"
                                text={confirm ? "본인인증완료" : "본인인증"} />
                        </div>

                        <div className="input-box margin_b-60">
                            <CustomTitle title="이메일"
                                marginBottom="10px" textAlign="left"
                                fontWeight="400" fontSize="14px" textColor="#ccc" />
                            <NormalInput type='email'
                                disabled={!confirm}
                                maxLength='100'
                                placeholder='이메일 주소를 입력해주세요.'
                                marginBottom='10px'
                                onFoucs={() => { setEmailErr(!validateEmail(email)); }}
                                onBlur={() => { setEmailErr(!validateEmail(email)); }}
                                onChange={handleEmailInput}
                                dispError={emailErr}
                                errText={emailErrTxt} />

                            <CustomTitle title="비밀번호 입력"
                                marginTop="20px"
                                marginBottom="10px" textAlign="left"
                                fontWeight="400" fontSize="14px" textColor="#ccc"
                            />
                            <NormalInput type='password'
                                disabled={!confirm}
                                maxLength='20'
                                placeholder='비밀번호를 입력해주세요.'
                                marginBottom='10px'
                                onChange={handlePasswdInput}
                                onFoucs={() => { setPasswdErr(!validatePassword(passwd)); }}
                                onBlur={() => { setPasswdErr(!validatePassword(passwd)); }}
                                dispError={passwdErr}
                                errText={passwdErrTxt} />
                            <NormalInput type='password'
                                disabled={!confirm}
                                maxLength='20'
                                placeholder='비밀번호를 한번 더 입력해주세요.'

                                onFoucs={() => { setPasswdComfirmErr(passwd !== passwdConfirm); }}
                                onBlur={() => { setPasswdComfirmErr(passwd !== passwdConfirm); }}
                                onChange={handlePasswdConfirmInput}
                                dispError={passwdConfirmErr}
                                errText={passwdConfirmErrTxt} />

                            <CustomTitle title="닉네임"
                                disabled={!confirm}
                                marginTop="20px"
                                marginBottom="10px" textAlign="left"
                                fontWeight="400" fontSize="14px" textColor="#ccc" />
                            <NormalInputGuide type='text'
                                disabled={!confirm}
                                maxLength='20'
                                value={confirm? nickname : ''}
                                placeholder={nicknameHolder}
                                guide="견적 요청 시 실명이 아닌 닉네임으로 주고받게 됩니다."
                                onChange={handleNicknameInput}
                                onFoucs={() => { setNickNameErr(!validateNickName(nickname)); }}
                                onBlur={() => { setNickNameErr(!validateNickName(nickname)); }}
                                dispError={nickNameErr}
                                errText={nickNameErrTxt} />
                        </div>

                        <div className="input-box input-check margin_b-30">
                            <CheckBoxInput title="전체 동의"
                                onClick={handleAllAgree}
                                defaultValue={allAgree}
                                labelmargin = {isMobileOnly?'0px 0px 0px 2vw':'0px 0px 0px 20px'} />
                            <hr className="member-hr_black"></hr>
                            <div>
                            <CheckBoxInput title="[필수] 14세 이상입니다."
                                onClick={handleAge} defaultValue={age}
                                margin="0px 0px 10px 0px"
                                labelmargin = {isMobileOnly?'0px 0px 0px 2vw':'0px 0px 0px 20px'}/>
                            </div>
                            <div>
                            <CheckBoxInput title="[필수] 서비스 이용약관에 동의합니다."
                                onClick={handlePolicy} defaultValue={policy}
                                margin="0px 0px 10px 0px" popup={true}
                                popupClick={handlePolicyPopup}
                                labelmargin = {isMobileOnly?'0px 0px 0px 2vw':'0px 0px 0px 20px'}/>
                            </div>
                            <div>
                            <CheckBoxInput title="[필수] 개인정보 수집 및 이용에 동의합니다."
                                onClick={handlePrivacy} defaultValue={privacy}
                                margin="0px 0px 10px 0px" popup={true}
                                popupClick={handlePrivacyPopup}
                                labelmargin = {isMobileOnly?'0px 0px 0px 2vw':'0px 0px 0px 20px'}/>
                            </div>
                            <div>
                            <CheckBoxInput title="[선택] 마케팅 수신에 동의합니다."
                                onClick={handleMarketing} defaultValue={marketing}
                                margin="0px 0px 10px 0px"
                                labelmargin = {isMobileOnly?'0px 0px 0px 2vw':'0px 0px 0px 20px'}/>
                            </div>
                        </div>

                        <NormalBtn width="100%"
                            lineHeight="58px"
                            textColor={submitEnable ? "#111" : "#bbb"}
                            bgColor={submitEnable ? "#ffc742" : "#e0e0e0"}
                            height="60px" borderRadius="30px"
                            fontSize="22px" fontWeight="500"
                            marginBottom="10px" marginTop="0px" float="none"
                            text="가입하기"
                            onClick={handleSubmit} />

                    </SuSignupBoxBlock>
                </SuSignupContentsBlock>
                <Footer />
            </LoadingOverlay>
            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopupComp()}
            </Modal>
        </SuSignupBlock>
    );
};

export default SuSignup;
